export const API_ENDPOINTS = {
  USER: { PROFILE: '/user/profile' },
  CURRICULUM: { BASE: '/curriculum' },
  CANDIDATES: { LIST: '/candidates', DETAIL: '/candidates' },
  ADMIN: { USERS: '/admin/users', GROUPS: '/admin/groups', METRICS: '/admin/metrics' },
}

export const STATUS = {
  IDLE: 'idle',
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
}

export const FIELD_TYPES = {
  TEXT: 'text',
  EMAIL: 'email',
  SELECT: 'select',
  TEXTAREA: 'textarea',
  DATE: 'date',
}